import { IAloBaseArray, AloBaseArray } from './AloBaseArray'

export interface IAloMissionPlanConstParam {
    id: number
    misId :number
    mptId :number|null
    libelle : string
    json : string
    detailLoaded:boolean
}

export class AloMissionPlan {    

    public id:number
    public misId:number
    public mptId:number|null
    public libelle:string
    public json:string
    public _detailLoaded:boolean

    constructor({id,misId,mptId,libelle,json,detailLoaded=false}:IAloMissionPlanConstParam = {} as IAloMissionPlanConstParam) {
        this.id = id
        this.misId = misId
        this.mptId = mptId
        this.libelle = libelle        
        this.json = json
        this._detailLoaded = detailLoaded
    }

    static createAloMissionPlanArray(datas:IAloBaseArray) {
        return new AloBaseArray(AloMissionPlan,datas)
    }

    static createAloMissionPlanWithDetail(data:any) {
        return new AloMissionPlan({...data,detailLoaded:true})
    }
}